
export const textFieldHandlerBuilder = (setter: React.Dispatch<React.SetStateAction<string>>) => {
    const handler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setter(e.target.value);
    }
    return handler;
};